/* eslint-disable react-hooks/exhaustive-deps */

import { useState, useEffect } from 'react';
import { SocialMediaLoginProps } from './useSocialSignIn.types';
import { useFacebook } from './type/useFacebook';
import { useGoogle } from './type/useGoogle';
import { useUser } from '@zoopla/user';
import { useGoogleOneTap } from './type/useGoogleOneTap';

export const useSocialSignIn = ({
    type,
    actionAfterAuth
}: SocialMediaLoginProps): [
    string,
    (rememberMe?: boolean) => void,
    boolean,
    () => void
] => {
    const [socialMediaError, setSocialMediaError] = useState('');
    const { registered } = useUser();
    const socialMediaAction = {
        onSuccess: actionAfterAuth?.action,
        onError: setSocialMediaError,
        eventLabel: actionAfterAuth?.eventLabel,
        segment: actionAfterAuth?.segment
    };

    const socialMediaMap = {
        facebook: useFacebook(socialMediaAction, { registered }),
        google: useGoogle(socialMediaAction, { registered }),
        googleOneTap: useGoogleOneTap(socialMediaAction, { registered })
    };

    useEffect(() => {
        initSocialMedia();
    }, []);

    const initSocialMedia = () => {
        if (!window) {
            return;
        }

        socialMediaMap[type]?.init();
    };

    const onSocialMediaSignIn = (rememberMe?: boolean) => {
        if (!window) {
            return;
        }
        setSocialMediaError('');
        socialMediaMap[type]?.onLogin(rememberMe);
    };

    const resetError = () => {
        setSocialMediaError('');
    };

    return [
        socialMediaError,
        onSocialMediaSignIn,
        socialMediaMap[type]?.isAuthenticating,
        resetError
    ];
};
